
const {
    common: {
        utils: {
            lazyload: {
                mixins: lazyloadMixins
            }
        }
    }
} = window.FEGORender

export {
    lazyloadMixins
}



// WEBPACK FOOTER //
// ./src/fego/FEGORender/index.js